import { render } from "./InventoryTypeFieldModal.vue?vue&type=template&id=07a30560&scoped=true"
import script from "./InventoryTypeFieldModal.vue?vue&type=script&lang=ts"
export * from "./InventoryTypeFieldModal.vue?vue&type=script&lang=ts"

import "./InventoryTypeFieldModal.vue?vue&type=style&index=0&id=07a30560&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07a30560"

export default script